import clsx from 'clsx';

import styles from './Skeleton.module.scss';

const Skeleton = ({ className, opacity = false }) => {
  return <div className={clsx(className, opacity ? styles.wrapperOpacity : styles.wrapper)} />;
};

export default Skeleton;
